const _markers = [];
let _userMarker = null;
let _markerCluster = null;
let _map = null;

const offices = {
    mixins: [mixins],
    data: function () {
        return {
            // default
            $this: [],
            isMounted: false,
            isLoading: false,
            // properties
            page: 1,
            viewMode: null,
            dictionary:
                typeof window.officesDictionary !== "undefined"
                    ? window.officesDictionary
                    : null,
            tags:
                typeof window.officesTagsData !== "undefined"
                    ? window.officesTagsData
                    : [],
            resultsOriginal:
                typeof window.officesData !== "undefined"
                    ? window.officesData
                    : [],
            results: [],
            resultsInBound: [],
            selectedResult: null,
            selectedTags: [],
            // properties
            defaultZoom: 15,
            address: null,
            autocompleteObj: [],
            place: null,
            placeViewportMarkers: [],
            // Map properties
            mapId: "map",
            closestMarker: null,
            map: null,
            bounds: null,
            userPos: null,
            markers: [],
            markersInBound: [],
            userMapIcon: "/imgs/icns/pinUser.png",
            mapIcon: "/imgs/icns/pin.svg",
            optionsStylesMap:
                typeof window.optionsStylesMap !== "undefined"
                    ? window.optionsStylesMap.data
                    : [],
            itemsPerPage: null,
            mcOptions: {
                styles: [
                    {
                        url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUGSURBVHgBzZkLTFNXGMdPO0uxvAoUEKmFgVIe5aHIgLWusMgSDQ5dMpURFc0WNUbDTIQFIg50zQRc5sLQRdmWbUTUTYLTGSuDIp0vhoIgMCYtHQ8rgdEX5VGg+05tSUdgrAjt/Sd/vu+ec+/lx+nl3O+cktA8pdfr6RAiwclgP2NON1oPVoI7wQpwDVhEIpFEaJ4iIQsFgHwIb4PTROK7ro1NrQgiqaGpBSmUKoOx6C7OyI/FNDg8LESfwItD8bzYQeiqAJ8G6Ea0GALAdWDh3wrlWI7g1Dh9BWcSubD0ltiXEze5a9/hiY5O2Ri+F9gXLZTgZi7gkwODg9pDGTk6S+Fm84696eOSTpkW3xv/jrk4SHNAsiBcLyw6t/JE/mmqUqW2+FH5L7GYyyePZaaP7tmxrQMON8Lj0IUsBQVIDoSrB44c9S4+9509WkQd+GDXSFFBXiukOwG2eaZzZgQFyNCBQUXF5pT3WeJ7dRRkBYWFsieqr12SurvSNwPsk+n9pBkgmRAuh8UlRjW3tlsF0iRuTNSo+OYVCaRvAWy3eR/Z/AAgnSGU7TucFWptSKzf7tdT93+Y7YMZgMXJvI887dyDZ0q+X/XV16VOyEY6+80Pzp9+VsyG9JB5+9RHD3/B8j87pLVvbtq+ortXbvXRNJezk+OktPFOh5ubSyo8AnW4zXxEP8k+XuBma0gslVpDzswVuEO639RmGFEYTXb7U8kV9tqEEEQg9Usamt3dXNNgVOtNI7o9Ky/fCxFMgsIiNwi4tpgaUaFPUPQbvfI+KiKQHB0dJtTdLdWQbiED5OqrNyqXEQ0SS6MZeqUC2CBdhT/68MrqWptNR3Op/lEjfn2/jkHDHre0OSCCqvbOA1xZeWBQ+54e+aIWHS+jtvYORwh+GNT92fO+pYigUmuGlkCgYlDqkFa7BBFUwIZfQAbQcUR8TWBQFY22dAwRVEY2JQZVOtBohAX1ZDA0EOQYtDPAz3cAEVTLPBlqCCoM2hcbvboXEVRBgQH9EFox6MOoSM5zRFCt5/PwkqSNBO96PIceo3mz04eHRwj1vocSTwWl3hko8z4iw49haLu7JWnDQ0QwcUIC8Tq/AeemerTp5MeZDxDBlJ+bXYtebLC9AIVRlTB9vJs3rE+oQwTRurjox69FRdQD2zN8bL5mqjz7uaDK3p46gmwsOt1FUZCXhQvmH01tU6BA3gl7QVUp7yZXIxtrd+rWqpjoNb8Ak8LU9q+dEpgBcLm3JzE5NaWyRsxDNlAinycWVpRegLQEQEdN7TNt6eBCdad/BC9dKuvyR1aUl5dHr/yP33MhvQiQSvO+6TslyHhCmbC89EsvT0YPspJ8Wcyn4hs/nYK0fDqkgWu2C2FkGRA2xidt3V0jvh+PFlF8bmy16PrFC0bI/pnOIc92sfGCctG1S+f3pr33rZOT44IXLnZ2dtpt7yRdBsgSOCybDdLAM9fNYGTtIKy5JRLzM44KNjU0PeGiBRA3Zu2t88WFPwcFvIrn7kfm/zjzAjUJgPEii3vz19ucjBxBskT2VzCsuxnIAlHsKFo+N0ZYVHBcyF7pL4WmBgCU/59r5/P1jSuEYDDzROEX4aLb94KkXV2+CqXaQ63WeOh0OpoBikLRUqkUrZenh4wTHNgSHRkhyz5ysAm68EZtFwBaVLG91JcHAO0JARvvW+FHhGaMWDowXjngSRtX6bhcGwRAHZqH/gG3FwPE0wLDywAAAABJRU5ErkJggg==",
                        width: 43,
                        height: 43,
                        textSize: 18,
                        textColor: "white",
                    },
                ],
            },
            autocompleteIsFocus: false,
            useMyLocationIsFocus: false,
            showInfoLabel: false,
        };
    },
    created: function () {
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    },
    mounted() {
        this.isMounted = true;

        this.setViewFromUrl();

        jQuery(document).on("google-map-ready", () => {
            if (navigator.geolocation) {
                this.getUserGeolocation();
            } else {
                this.iniGoogleApps();
            }
        });
    },
    methods: {
        setViewFromUrl: function () {
            var view = this.getUrlParam("view", null);
            this.setViewMode(view);
        },

        iniGoogleApps() {
            this.results = this.resultsOriginal;

            this.iniAddressField();
            this.iniMap();
        },

        async getUserGeolocation() {
            await navigator.geolocation.getCurrentPosition(
                (pos) => {
                    // allow
                    //console.log('allow')
                    this.userPos = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    };
                    this.iniGoogleApps();
                },
                () => {
                    // block
                    //console.log('block')
                    this.iniGoogleApps();
                    this.showInfoLabel = true;
                }
            );
        },

        removeUserMarker: function () {
            if (!this.hasValue(_userMarker)) {
                return false;
            }
            _userMarker.setMap(null);
        },

        addUserMarker: function (position) {
            if (!this.hasValue(position)) {
                return false;
            }

            _userMarker = new google.maps.Marker({
                position: position,
                map: this.map,
                icon: this.userMapIcon,
            });

            _userMarker.addListener("click", () => {
                this.map.setCenter(position);
                this.map.setZoom(this.defaultZoom);
            });
        },

        //onChangeTag: function () {

        //	this.selectedResult = null

        //	// no tags selected
        //	if (!this.selectedTags.length) {
        //		this.results = this.resultsOriginal;
        //	}
        //	else {
        //		this.results = [];

        //		this.selectedTags.forEach((item, index) => {
        //			var elems = this.resultsOriginal.filter((i) =>
        //				i.tags.includes(item)
        //			);
        //			this.results.push(elems);
        //		});

        //		this.results = this.results.flat();
        //		// remove duplicates by id
        //		this.results = this.results.filter(
        //			(v, i, a) => a.findIndex((t) => t.id === v.id) === i
        //		);
        //	}
        //	this.iniMap()
        //},

        onChangeTag: function () {
            this.selectedResult = null;

            // no tags selected
            if (!this.selectedTags.length) {
                this.results = this.resultsOriginal;
            } else {
                this.results = [];

                this.selectedTags.forEach((item, index) => {
                    var elems = this.resultsOriginal.filter((i) =>
                        i.tags.includes(item)
                    );
                    this.results.push(elems);
                });

                this.results = this.results.flat();
                // remove duplicates by id
                this.results = this.results.filter(
                    (v, i, a) => a.findIndex((t) => t.id === v.id) === i
                );
            }

            this.iniPage();
            this.hideMarkers();
            this.getMarkersInBound();
            this.scrollToElem(jQuery(this.$refs.tags));
        },

        hideMarkers: function () {
            _markerCluster.clearMarkers();

            _markers.forEach((i) => {
                var index = this.results.findIndex((x) => x.id === i.id);
                if (index === -1) {
                    i.setMap(null);
                } else {
                    i.setMap(this.map);
                    _markerCluster.addMarker(i);
                }
            });
        },

        iniAddressField: function () {
            var options = {
                componentRestrictions: { country: "gr" },
                types: ["geocode"],
            };

            const autocomplete = new google.maps.places.Autocomplete(
                this.$refs.address,
                options
            );

            autocomplete.addListener("place_changed", () => {
                this.place = autocomplete.getPlace();

                if (!this.place.geometry || !this.place.geometry.location) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    console.warn(
                        "No details available for input: '" +
                            this.place.name +
                            "'"
                    );
                    this.results = [];
                    return;
                }

                this.iniPage();
                this.selectedResult = null;

                this.removeUserMarker();
                this.addUserMarker(this.place.geometry.location);

                var lat = this.place.geometry.location.lat();
                var lng = this.place.geometry.location.lng();
                this.setLocationsRad(lat, lng);

                this.scrollToElem(jQuery(this.$refs.tabs), 50);
                this.$refs.address.blur();

                this.placeViewportMarkers = this.markers.filter((i) =>
                    this.place.geometry.viewport.contains(i.getPosition())
                );

                switch (this.placeViewportMarkers.length) {
                    case 0:
                        console.log("no markers in place viewport");
                        this.findClosestMarker();
                        this.fitBoundsToPlaceClosestMarker();
                        break;
                    default:
                        console.log("some markers in place viewport");
                        this.fitBoundsToPlaceViewport();
                }
            });
        },

        createViewportRectangle: function () {
            const rectangle = new google.maps.Rectangle();

            // Get the current bounds, which reflect the bounds before the zoom.
            rectangle.setOptions({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                map: this.map,
                bounds: this.place.geometry.viewport,
            });
        },

        fitBoundsToPlaceViewport: function () {
            this.map.fitBounds(this.place.geometry.viewport);
        },

        fitBoundsToPlaceClosestMarker: function () {
            var bounds = new google.maps.LatLngBounds();

            bounds.extend(this.closestMarker.getPosition());
            bounds.extend(this.place.geometry.location);

            this.map.fitBounds(bounds);
        },

        fitBoundsByUserLocationToClosestMarker(userPos) {
            var bounds = new google.maps.LatLngBounds();

            bounds.extend(this.closestMarker.getPosition());
            bounds.extend(userPos);

            this.map.fitBounds(bounds);
        },

        iniMap: function () {
            var element = document.getElementById(this.mapId);

            if (element === null) {
                return false;
            }

            var options = {
                mapTypeControl: false,
                fullScreenControl: false,
                styles: this.optionsStylesMap,
            };
            this.map = _map = new google.maps.Map(element, options);

            this.results.forEach((i, index) => {
                var _position = new google.maps.LatLng(i.lat, i.lng);

                var marker = new google.maps.Marker({
                    position: _position,
                    map: this.map,
                    icon: this.mapIcon,
                    id: i.id,
                    title: i.title,
                });

                // DO NOT REMOVE helping variable 'markers'
                // new MarkerClusterer method does not accept a vue.js data property as a parameter
                _markers.push(marker);
                this.markers.push(marker);

                google.maps.event.addListener(
                    marker,
                    "click",
                    ((marker, index) => {
                        return () => {
                            this.map.setZoom(
                                this.map.getZoom() > this.defaultZoom
                                    ? this.map.getZoom()
                                    : this.defaultZoom
                            );

                            if (api.vars.windW < api.vars.scr.tablet) {
                                this.scrollToElem(
                                    jQuery(".s-offices__selected"),
                                    200
                                );
                            }

                            this.map.setCenter(marker.getPosition());
                            this.selectedResult = this.results.find(
                                (i) => i.id === marker.id
                            );
                        };
                    })(marker, index)
                );
            });

            this.bounds = new google.maps.LatLngBounds();

            if (!this.userPos) {
                this.markers.forEach((i) => {
                    this.bounds.extend(i.position);
                });
                this.map.fitBounds(this.bounds);
            } else {
                this.map.setCenter(this.userPos);
                this.map.setZoom(this.defaultZoom);
            }

            // Add a marker clusterer to manage the markers.
            _markerCluster = new MarkerClusterer(
                _map,
                _markers,
                this.mcOptions
            );

            google.maps.event.addListener(
                this.map,
                "bounds_changed",
                function (event) {
                    // some handling code here
                    this.getMarkersInBound();
                }.bind(this)
            );

            this.removeUserMarker();
            this.addUserMarker(this.userPos);
        },

        getMarkersInBound: function () {
            this.markersInBound = this.markers.filter((i) =>
                this.map.getBounds().contains(i.getPosition())
            );

            this.resultsInBound = this.results.filter((i) =>
                this.markersInBound.find((j) => j.id === i.id)
            );
        },

        setViewMode: function (value) {
            if (!this.hasValue(value)) {
                return false;
            }

            this.viewMode = value;
            this.appendUrlParams(["view"], [value]);
        },

        clearSelectedResult: function () {
            this.selectedResult = null;
        },

        iniPage: function () {
            this.page = 1;
        },

        pageChanged(value) {
            this.scrollToElem(jQuery(this.$refs.viewList), 150);
            this.page = value;
        },

        setLocationsRad: function (lat, lng) {
            if (!this.hasValue(lat) || !this.hasValue(lng)) {
                return false;
            }

            var R = 6371; // radius of earth in km

            this.resultsOriginal.forEach((i) => {
                var mlat = i.lat;
                var mlng = i.lng;
                var dLat = this.rad(mlat - lat);
                var dLong = this.rad(mlng - lng);
                var a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(this.rad(lat)) *
                        Math.cos(this.rad(lat)) *
                        Math.sin(dLong / 2) *
                        Math.sin(dLong / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;
                i.rad = d;
            });
        },

        findClosestMarker: function () {
            var lat = this.place.geometry.location.lat();
            var lng = this.place.geometry.location.lng();
            this.findClosestMarkerFN(lat, lng);
        },

        findClosestMarkerFN(lat, lng) {
            var R = 6371; // radius of earth in km
            var distances = [];
            var closest = -1;

            for (i = 0; i < _markers.length; i++) {
                // check only visible markers
                var index = _markerCluster.markers_.findIndex(
                    (x) => x.id === _markers[i].id
                );

                if (index < 0) {
                    continue;
                }

                var mlat = _markers[i].position.lat();
                var mlng = _markers[i].position.lng();
                var dLat = this.rad(mlat - lat);
                var dLong = this.rad(mlng - lng);
                var a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(this.rad(lat)) *
                        Math.cos(this.rad(lat)) *
                        Math.sin(dLong / 2) *
                        Math.sin(dLong / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;
                distances[i] = d;
                if (closest == -1 || d < distances[closest]) {
                    closest = i;
                }
            }

            this.closestMarker = _markers[closest];

            console.log("closestMarker:", this.closestMarker);
        },

        rad: function (x) {
            return (x * Math.PI) / 180;
        },

        isFocusAutocomplete(focus) {
            setTimeout(() => {
                this.autocompleteIsFocus = focus;
            }, 50);
        },

        onClickMyLocation: function () {
            this.removeUserMarker();
            this.addUserMarker(this.userPos);
            this.map.setCenter(this.userPos);
            //this.map.setZoom(this.defaultZoom);
            this.scrollToElem(jQuery(this.$refs.map), 50);
            this.$refs.useMyLocationButton.blur();
            this.$refs.address.value = "";

            this.findClosestMarkerFN(this.userPos.lat, this.userPos.lng);
            this.fitBoundsByUserLocationToClosestMarker(this.userPos);
        },

        //moveMapToLocation: function () {

        //	if (!this.place) {
        //		return false
        //	}

        //	if (!this.place.geometry) {
        //		return false
        //	}
        //	this.map.fitBounds(this.place.geometry.viewport)
        //},
    },
    computed: {
        showUseMyLocation: function () {
            // if (!this.hasValue(this.userPos)) {
            // 	return false
            // }

            if (this.useMyLocationIsFocus || this.autocompleteIsFocus) {
                return true;
            }

            return false;
        },

        resultsByRad: function () {
            numArray = numArray.sort(function (a, b) {
                return a - b;
            });
        },

        showMyLocationButton: function () {
            return this.hasValue(this.userPos);
        },

        resultsInBoundPaged: function () {
            var start = (this.page - 1) * this.itemsPerPage;
            var end = this.page * this.itemsPerPage;

            return this.resultsInBound.slice(start, end);
        },

        noResults: function () {
            return !!(
                !this.resultsInBound.length &&
                this.place &&
                this.mapIdle
            );
        },
    },
};

var officesApp = Vue.createApp(offices);
officesApp.directive("init", initDirective);
officesApp.component("e-loader", eLoader);
officesApp.component("b-office", bOffice);
officesApp.component("b-pagination", bPagination);

const selOffices = document.querySelector("#v-offices");
if (selOffices) officesApp.mount(selOffices);
